import React from 'react';

const LoadingSkeleton = () => (
  <div className="flex flex-wrap gap-3">
    {[0, 1, 2, 3].map((item) => (
      <span key={item} className="h-10 w-28 animate-pulse rounded-full bg-white/10" />
    ))}
  </div>
);

export default LoadingSkeleton;

